export default __webpack_public_path__ + "static/media/flyingRock3.719351ca.webp";